export default {
    baseStyle: {
        showMoreContainer: {
            marginTop: {base: 12, lg: 16},
        },
        showMoreButton: {
            width: {base: '100%'},
            maxWidth: {base: '100%', lg: '342px'}
        }
    }
}
